import type { CountriesResponse, CountryOption } from '../../shared/types/index.js';
import { request } from './client.js';

/** Countries enabled on the upstream platform (assignable to accounts). */
export async function fetchCountries(): Promise<Array<CountryOption>> {
  const { countries } = await request<CountriesResponse>('/countries');
  return countries;
}
